module.exports = __webpack_public_path__ + "img/default_a4.5580bbf5.png";